import React, { useCallback } from 'react'
import { Platform } from 'react-native'
import { peek } from 'utils/stacks'
import {
  TARGET_FORGOT_PASSWORD,
  TARGET_RESET_PASSWORD,
} from 'utils/forgotPassword'
import Screen from '../components/Screen'
import ErrorScreen from '../components/Error'
import { ForgotPassword, ResetPassword } from '../components/ForgotPassword'

export const useScreenRendering = ({ app, layoutGuides, previewType }) => {
  const renderCurrentScreen = useCallback(
    routeStack => {
      if (!routeStack) {
        return null
      }

      const currentRoute = peek(routeStack)
      const currentComponent = app.components[currentRoute.target]

      const stackInfo = {
        stack: routeStack.map(route => ({
          target: route.target,
          transition: route.transition,
          params: route.params,
        })),
        currentRoute: currentRoute.target,
        stackLength: routeStack.length,
      }

      if (Platform.OS === 'web') {
        stackInfo.historyState = window.history.state
        stackInfo.historyLength = window.history.length
      }

      if (currentRoute.target === TARGET_FORGOT_PASSWORD) {
        return (
          <ForgotPassword
            layoutGuides={layoutGuides}
            datasourceId={Object.keys(app.datasources)[0]}
          />
        )
      }
      if (currentRoute.target === TARGET_RESET_PASSWORD) {
        return (
          <ResetPassword
            layoutGuides={layoutGuides}
            datasourceId={Object.keys(app.datasources)[0]}
          />
        )
      }
      if (currentComponent) {
        return (
          <Screen
            key={currentComponent.id}
            topScreen
            component={currentComponent}
            params={currentRoute.params}
            layoutGuides={layoutGuides}
            previewType={previewType}
          />
        )
      }

      return <ErrorScreen message="Screen Missing" />
    },
    [app.components, app.datasources, layoutGuides, previewType]
  )

  const renderPreviousScreen = useCallback(
    (routeStack, previousRoute) => {
      if (!previousRoute) {
        return <ErrorScreen message="Screen Missing" />
      }

      const previousComponent = app.components[previousRoute.target]

      if (previousComponent) {
        return (
          <Screen
            key={previousComponent.id}
            topScreen={false}
            component={previousComponent}
            params={previousRoute.params}
            layoutGuides={layoutGuides}
            previewType={previewType}
          />
        )
      }

      return <ErrorScreen message="Screen Missing" />
    },
    [app.components, layoutGuides, previewType]
  )

  return {
    renderCurrentScreen,
    renderPreviousScreen,
  }
}
